<p>{{ parentComponentData }}</p>

<div class="modal-footer">
  <button type="button" (click)="onClose()" class="btn btn-secondary">
    OK
  </button>
</div>
